import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import LineChart from "../charts/LineChart";
import employedSwitzerland from "../../data/employedSwitzerland";
import trendEmployeesSwitzerland from "../../data/trendEmployeesSwitzerland";
import trendNeedEmployees from "../../data/trendNeedEmployees";
import trendAvailabilityEmployees from "../../data/trendAvailabilityEmployees";
import cumulativeDemographic from "../../data/cumulativeDemographic";
import netImmigrationCh from "../../data/netImmigrationCh";
import netImmigrationPT from "../../data/netImmigrationPT";
import netImmigrationDE from "../../data/netImmigrationDE";
import netImmigrationFR from "../../data/netImmigrationFR";
import netImmigrationIT from "../../data/netImmigrationIT";
import BarChart from "../charts/BarChart";
import fulltimeJobsCH from "../../data/fulltimeJobsCH";
import fulltimeJobsCHIndustrial from "../../data/fulltimeJobsCHIndustrial";
import fulltimeJobsCHService from "../../data/fulltimeJobsCHService";
import watchIndustry from "../../data/watchIndustry";
import memIndustrial from "../../data/memIndustrial";
import retail from "../../data/retail";
import healthcare from "../../data/healthcare";
import ict from "../../data/ict";


const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-6/12 flex-shrink-0 relative`;
const Image = styled.img(props => [
    props.imageRounded && tw`rounded`,
    props.imageBorder && tw`border`,
    props.imageShadow && tw`shadow`,
]);


const fulltimeJobsCHData = {
    label: "",
    data: fulltimeJobsCH,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const fulltimeJobsCHIndustrialData = {
    label: "",
    data: fulltimeJobsCHIndustrial,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const fulltimeJobsCHServiceData = {
    label: "",
    data: fulltimeJobsCHService,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}


const watchIndustryData = {
    label: "",
    data: watchIndustry,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}


const memIndustrialData = {
    label: "",
    data: memIndustrial,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const retailData = {
    label: "",
    data: retail,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const healthcareData = {
    label: "",
    data: healthcare,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const ictData = {
    label: "",
    data: ict,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}



export default ({
                    title = "",
                    d1 = "",
                    d2="",
                    d3 = "",
                    d4 = "",
                    d5 = "",
                    d6 = "",
                    image1="",
                    image2="",
                    image3="",
                }) => {
    return (
        <>
            <h1>{title}</h1>
            <p>
                {d1}
            </p>
            <div  style={{textAlign:'center',margin:'3% 0% 3% 0%'}}>
                <ImageColumn style={{marginLeft:'auto',marginRight:'auto'}}>
                    <LineChart
                        data={[fulltimeJobsCHData]}
                        title="Full-time jobs CH Total"
                        legend={false}
                        xLabel=" - III"
                    />
                    <LineChart
                        data={[fulltimeJobsCHIndustrialData]}
                        title="Full-time positions in the CH industrial sector"
                        legend={false}
                        xLabel=" - III"
                    />
                    <LineChart
                        data={[fulltimeJobsCHServiceData]}
                        title="Employment statistics CH service sector"
                        legend={false}
                        xLabel=" - III"
                    />
                    <p>
                        {image1}
                    </p>
                </ImageColumn>
            </div>
            <p>
                {d2}
            </p>
            <div  style={{textAlign:'center',margin:'3% 0% 3% 0%'}}>
                <ImageColumn style={{marginLeft:'auto',marginRight:'auto'}}>
                    <LineChart
                        data={[watchIndustryData]}
                        title="Watch industry"
                        legend={false}
                        xLabel=" - III"
                    />
                    <LineChart
                        data={[memIndustrialData]}
                        title="MEM-industrial"
                        legend={false}
                        xLabel=" - III"
                    />
                    <p>
                        {image2}
                    </p>
                </ImageColumn>
            </div>
            <p>
                {d3}
            </p>
            <div  style={{textAlign:'center',margin:'3% 0% 3% 0%'}}>
                <ImageColumn style={{marginLeft:'auto',marginRight:'auto'}}>
                    <LineChart
                        data={[retailData]}
                        title="Retail trade"
                        legend={false}
                        xLabel=" - III"
                    />
                    <LineChart
                        data={[healthcareData]}
                        title="Healthcare"
                        legend={false}
                        xLabel=" - III"
                    />
                    <LineChart
                        data={[ictData]}
                        title="ICT"
                        legend={false}
                        xLabel=" - III"
                    />
                    <p>
                        {image3}
                    </p>
                </ImageColumn>
            </div>
            <p>
                {d4}
            </p>
            <p>
                {d5}
            </p>
            <p>
                {d6}
            </p>

        </>
    );
};
